<template>
    <el-dialog
        width="500px"
        :title="pageType ==1 ? '添加产品' : '修改产品'"
        top="3vh"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >
        <el-form ref="formData" class="query-form" size="mini" :rules="rules" :model="formData">
            <el-form-item label="中文品名：" class="query-form-item" prop="product_cn_name">
                <el-input v-model="formData.product_cn_name" placeholder="请输入中文品名" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="英文品名：" class="query-form-item" prop="product_en_name">
                <el-input v-model="formData.product_en_name" placeholder="请输入英文品名" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="产品数量：" prop="product_number">
                <el-input-number
                    v-model="formData.product_number"
                    style="width: 300px;" :min="0" :step="1" size="mini"
                    placeholder="请输入产品数量"
                >
                </el-input-number>
            </el-form-item>

            <el-form-item label="发票Asin：" class="query-form-item" prop="product_detail_id">
                <el-select v-model="formData.product_detail_id" placeholder="请选择" size="mini" filterable
                           style="width: 240px;">
                    <el-option :label="item.asin" :value="item.id" v-for="item in asinList"></el-option>
                </el-select>
                <el-button @click="openAddAsin" type="success" size="mini"
                           style="margin-left: 5px">
                    添加发票Asin
                </el-button>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
            <el-button @click="addProduct" type="success" size="mini" v-show="pageType==1">添加</el-button>
            <el-button @click="addProduct" type="success" size="mini" v-show="pageType==2">修改</el-button>
         </span>

        <add-asin ref="addAsinDom" @addAsin="addAsinCallBack"></add-asin>
    </el-dialog>
</template>
<script>
    import AddAsin from './addAsin'

    export default {
        components: {AddAsin},
        data() {
            return {
                pageType: 1,
                rules: {
                    product_cn_name: [
                        {
                            required: true,
                            message: '请输入中文品名',
                            trigger: 'blur'
                        },
                    ],
                    product_en_name: [
                        {
                            required: true,
                            message: '请输入英文品名',
                            trigger: 'blur'
                        },
                    ],
                    product_number: [
                        {
                            required: true,
                            message: '请输入产品数量',
                            trigger: 'blur'
                        },
                    ],
                    product_detail_id: [
                        {
                            required: true,
                            message: '请选择发票Asin',
                            trigger: 'blur'
                        },
                    ],
                },
                visible: false,
                formData: {
                    product_cn_name: undefined,
                    product_en_name: undefined,
                    product_number: undefined,
                    product_detail_id: undefined,
                },
            }
        },
        props: {
            asinList: {
                type: Array,
                default: []
            }
        },
        methods: {
            addAsinCallBack() {
                this.$emit('addAsinCallBack')
            },
            openAddAsin() {
                this.$refs.addAsinDom.openModal()
            },
            // 打开当前modal
            openModal(type, data) {
                this.pageType = type
                if (type == 2) {
                    this.formData = data
                }
                this.visible = true
            },
            showModal(data) {
                this.formData = data
                this.visible = true
            },
            // 关闭弹窗
            handleClose() {
                this.visible = false
                this.$emit('close-callback', {flag: false})
            },
            addProduct() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        this.$emit('close-callback', {
                            flag: true,
                            pageType: this.pageType,
                            data: JSON.parse(JSON.stringify(this.formData))
                        })
                        this.initFormData()
                        this.visible = false
                    } else {
                        this.loading = false
                        this.$message({type: 'error', message: '请填写相应内容！'})
                    }
                })
            },
            initFormData() {
                this.formData = {
                    specification: undefined,
                    box_number: undefined,
                    box_weight: undefined,
                }
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .subTitle {
        height: 30px;
        font-size: 18px;
        font-weight: 800;
        margin: 5px 0 0;
    }

    .subTitle2 {
        height: 20px;
        font-size: 16px;
        font-weight: 800;
    }

    .itemInfo {
        display: flex;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 800;
        }

        .itemContent {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .itemInfo:not(:first-child) {
        margin-top: 5px;
    }

    .lineDom {
        width: auto;
        height: 1px;
        background: black;
        margin: 10px 0;
    }

    .wrapBox {
        width: 600px;
        margin-top: 10px;

        .bottomBox {
            margin-top: 17px;
            display: flex;
            justify-content: center;
        }
    }

    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto 20px;
        width: 60%;
        display: flex;
        justify-content: space-between;
    }
</style>
